import React from "react";
import { HeaderProps } from "./types/header.types";
import { useHeader } from "./hooks/useHeader";
import { HEADER_HEIGHT } from "./constants/navigation.constants";

import Logo from "./components/Logo";
import SearchBar from "./components/SearchBar";
import MenuButton from "./components/MenuButton";
import UserActions from "./components/UserActions";
import MobileMenu from "./components/MobileMenu";
import MegaMenu from "./components/MegaMenu";

import { hotjar } from 'react-hotjar';

import "./styles/variables.css";
import "./styles/header.css";

const Header: React.FC<HeaderProps> = ({
  variant = "fixed",
  height = HEADER_HEIGHT,
  onMenuToggle,
  onSearch,
}) => {

/*
hjid: Stands for 'Hotjar ID' - Your site's ID. This is the ID which tells Hotjar which site settings it should load and where it should save the data collected.

hjsv: Stands for 'Hotjar Snippet Version' - The version of the Tracking Code you are using. This is only needed if Hotjar ever updates the Tracking Code and needs to discontinue older ones. Knowing which version your site includes allows hotjar team to contact you and inform you accordingly.
*/
  const hjid = 3323441;
  const hjsv = 6;
  hotjar.initialize({ id: hjid, sv: hjsv });

  const {
    isMenuOpen,
    searchTerm,
    toggleMenu,
    closeMenu,
    handleSearchChange,
    handleSearch,
  } = useHeader();

  const handleMenuToggle = () => {
    toggleMenu();
    onMenuToggle?.();

    if (!isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      setTimeout(() => {
        document.body.style.overflow = "visible";
      }, 260);
    }
  };

  const handleMenuClose = () => {
    closeMenu();
    setTimeout(() => {
      document.body.style.overflow = "visible";
    }, 260);
  };

  const handleSearchSubmit = (term: string) => {
    if (onSearch) {
      onSearch(term);
    } else {
      handleSearch(term);
    }
  };

  const searchProps = {
    value: searchTerm,
    onChange: handleSearchChange,
    onSearch: handleSearchSubmit,
  };

  return (
    <>
      <header
        className="header position-fixed w-100"
        style={{
          height: `${height}px`,
          backgroundColor: "#232944",
        }}
      >
        {/* Desktop menu */}
        <div className="desktop-menu d-none d-lg-block">
          <div className="header-full-width">
            <div
              className="d-flex align-items-center justify-content-between"
              style={{ height: "93px" }}
            >
              <div className="d-flex align-items-center">
                <Logo variant="desktop" />

                <MenuButton onClick={handleMenuToggle} isOpen={isMenuOpen} />
              </div>

              <div
                className="d-flex align-items-center"
                style={{ gap: "20px" }}
              >
                <div className="header-search-wrapper">
                  <SearchBar {...searchProps} />
                </div>

                <div className="header-user-actions">
                  <UserActions variant="desktop" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Header */}
        <div className="mobile-header d-lg-none">
          <div className="mobile-header-content">
            <div
              className="d-flex align-items-center justify-content-between"
              style={{ height: "70px", padding: "0 20px" }}
            >
              {/* Logo Forluz Mobile */}
              <div className="mobile-logo">
                <Logo variant="mobile" />
              </div>

              {/* Botão Hambúrguer */}
              <button
                className="mobile-hamburger"
                onClick={handleMenuToggle}
                aria-label="Abrir menu"
              >
                <span></span>
                <span></span>
                <span></span>
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Desktop Mega Menu */}
      <MegaMenu isOpen={isMenuOpen} onClose={handleMenuClose} />

      {/* Mobile Menu */}
      <MobileMenu
        isOpen={isMenuOpen}
        onClose={handleMenuClose}
        searchProps={searchProps}
      />
    </>
  );
};

export default Header;
